// extracted by mini-css-extract-plugin
export default {"zooplus":"-tUZAfvYA-3NSz0jfWXwm","bitiba":"_29QVdGKsEICcmQDVF6cLyn"};